import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FullscreenSpinner from '../../components/FullscreenSpinner';
import useSoilAnalyses from './useSoilAnalyses';
import { SoilAnalysesPage, NewSoilAnalysesPage } from './SoilAnalysesPage';
import SoilAnalysesHome from './SoilAnalysesHome';

const SoilAnalyses = () => {

  const { isLoading } = useSoilAnalyses();

  return (
    <>
      <FullscreenSpinner loading={isLoading} />
      <Routes>
        <Route path='/' element={<SoilAnalysesHome />} />
        <Route path='new' element={<NewSoilAnalysesPage />} />
        <Route path=':soilAnalysesId' element={<SoilAnalysesPage />} />
      </Routes>
    </>
  );
};

export default SoilAnalyses;
